import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { SectionEyebrow } from "./SectionEyebrow";
import { buildLocalizedPath } from "../lib/langRoutes";

const DOCTOR_IMG = "/dr-hirschhausen.jpg";

export const DoctorBlock = () => {
  const { t, i18n } = useTranslation();
  const { ref, inView } = useScrollReveal({ threshold: 0.1 });
  const lang = i18n.language?.split("-")[0] || "de";

  return (
    <section
      id="medico"
      data-testid="doctor-block"
      className="py-24 lg:py-36 bg-[#F6F5F2]"
    >
      <div
        ref={ref}
        className={`reveal ${inView ? "in-view" : ""} max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center`}
      >
        <div className="lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden bg-[#EFEDE6]">
            <img
              src={DOCTOR_IMG}
              alt="Dr. Karl Ernst Von Hirschhausen — KosMedico Zürich"
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-[#1F2D1D]/75 to-transparent pointer-events-none" />
            <div className="absolute bottom-5 left-5 right-5 text-[#F6F5F2]">
              <div className="overline text-[#A7CA99]/90">{t("about.doctor_title")}</div>
              <div className="font-serif text-xl lg:text-2xl font-light mt-1 leading-tight">
                {t("about.doctor_name")}
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <SectionEyebrow num="07">{t("doctor.eyebrow")}</SectionEyebrow>
          <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl font-light tracking-tight leading-[1.05] text-[#3E5239]">
            {t("doctor.title_l1")}
            <br />
            <span className="italic text-[#A7CA99]">{t("doctor.title_l2")}</span>
          </h2>

          <p className="mt-8 text-[#6B7A66] font-light leading-relaxed max-w-xl">
            {t("doctor.bio_short")}
          </p>

          <Link
            to={buildLocalizedPath("about", lang)}
            data-testid="doctor-block-link"
            className="mt-10 inline-flex items-center gap-2 overline text-[#3E5239] border-b border-[#A7CA99] hover:border-[#3E5239] pb-1 transition-colors group"
          >
            {t("doctor.cta")}
            <ArrowRight size={14} weight="bold" className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};
